/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

const RUBRICS_PATH = '/rubrics';

/**
 * Paths for the portal's own rubrics API. The tenant travels in the berlin-tenant-id header, and
 * graphId is an optional query param rather than a path segment: SDK tenants have no graph to
 * scope to. These replace the graph-scoped eval routes the studio module owns.
 */
const withScope = (path, params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '') {
      query.set(key, value);
    }
  });
  const search = query.toString();
  return search ? `${path}?${search}` : path;
};

const rubricPath = (rubricId, suffix = '') => `${RUBRICS_PATH}/${encodeURIComponent(rubricId)}${suffix}`;

export const buildRubricsListPath = ({ graphId }) => withScope(RUBRICS_PATH, { graphId });

export const buildRubricsCreatePath = ({ graphId }) => withScope(RUBRICS_PATH, { graphId });

export const buildRubricsDetailPath = ({ rubricId, graphId }) => withScope(rubricPath(rubricId), { graphId });

export const buildRubricsDeletePath = ({ rubricId, graphId }) => withScope(rubricPath(rubricId), { graphId });

export const buildRubricsTextPath = ({ rubricId, graphId }) =>
  withScope(rubricPath(rubricId, '/rubrictext'), { graphId });

export const buildRubricsSchedulerPath = ({ rubricId, graphId }) =>
  withScope(rubricPath(rubricId, '/scheduler'), { graphId });

export const buildRubricsSearchPath = ({ graphId, q, limit }) =>
  withScope(`${RUBRICS_PATH}/search`, { graphId, q, limit });

/** One enhance endpoint for both cases: rubricId is absent before the first save. */
export const buildRubricsEnhancePath = ({ graphId, rubricId }) =>
  withScope(`${RUBRICS_PATH}/enhance`, { graphId, rubricId });
